import React from 'react';
import imgUrlToResizeUrl from 'helpers/imgUrlToResizeUrl';

const AdwertImage = props => {
  const { img, url, ...rest } = props;
  return (
    img
      ? <a className="adwert-image" href={url} target="_blank" rel="noopener noreferrer">
        {/* <img className="adwert-image__img" src={img} alt="" /> */}
        <picture>
          <source className="adwert-image__img" srcSet={imgUrlToResizeUrl(img, 400, 400, 'resize')} />
          <img srcSet={imgUrlToResizeUrl(img, 400, 400, 'resize')} className="adwert-image__img" alt="" />
        </picture>
      </a>
      : <></>
  );
}

export default AdwertImage;